<template>
  <v-card>
    <v-toolbar flat id='manageTable'>
      <v-toolbar-title class='display-1 fontcolor'>{{
        TABLE_TITLE
      }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <template >
      <div class="mt-1" style="box-shadow: 0px 1px 3px rgba(9, 35, 58, 0.16);">
        <v-card-title class='body-1 fontcolor'>{{SEARCH_COUNTY}}</v-card-title>
        <v-row class="ml-2 mr-2 mb-8 mt-2">
        <v-col class="d-flex" cols="4" lg="4" sm="4" >
          <v-autocomplete
          class="caption"
          v-model="filterItem.countryId"
            :items='countryList'
            item-text='name'
            item-value='id'
            label="Country"
            dense
            @change="filterState"
            :loading="loadingCountry"
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="4" lg="4" sm="4" >
          <v-autocomplete
          class="caption"
          v-model="filterItem.stateId"
            :items='stateList'
            item-text='name'
            item-value='id'
            label="State"
            @change="filterCounty"
            :loading="loadingState"
            dense
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="4" lg="4" sm="4">
          <v-autocomplete
          class="caption"
          v-model="filterItem.id"
            :items='counties'
            label="County"
            :item-text='customCountyName'
            item-value='id'
            dense
            :loading="loadingCounty"
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="4" lg="4" sm="4">
          <v-autocomplete
          class="caption"
          v-model="filterItem.fipsId"
            :items='fipsList'
            label="FIPS"
            item-text='name'
            item-value='id'
            dense
            :loading="loadingFips"
          ></v-autocomplete>
        </v-col>
        <v-col class="d-flex" cols="4" lg="4" sm="4">
          <v-autocomplete
          class="caption"
          v-model="filterItem.fstatus"
            :items='defaultStatusItems'
            label="Status"
            item-text='name'
            item-value='statusFieldId'
            dense
          ></v-autocomplete>
        </v-col>
        <v-col style="text-align:right !important" class="text-lg-right pa-0 mt-n4" cols="12">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text small class='mr-2 text-lg-right text-capitalize' @click="onReset">Reset</v-btn>
            </template>
            <span>Reset</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn  v-on="on" outlined dark class='mb-2 fontcolor mr-2 text-lg-right' color="success" @click="searchCounties"><v-icon>mdi-magnify</v-icon> Search</v-btn>
            </template>
            <span>Search</span>
          </v-tooltip>
        </v-col>
        <v-spacer></v-spacer>
      </v-row>
      </div>
    </template>
    <v-data-table
      :loading='loading'
      :headers='headers'
      :items='searchCountyList'
      :search='search'
      class='elevation-1'
    >
      <template v-slot:top>
        <v-toolbar flat id='manageTable'>
          <v-spacer></v-spacer>
         <v-dialog default v-model='dialog' max-width='500px' scrollable>
            <template v-slot:activator='{ on }'>
              <v-btn outlined dark class='mb-2 fontcolor' v-on='on'  @click="hideEditedFields">
                <v-icon dark>mdi-plus</v-icon>
                {{ ADD_NEW_COUNTY }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class='headline fontcolor'>{{ formTitle }}</span>
              </v-card-title>
              <v-card class="pl-7 pr-6 pt-5 pb-5" >
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model='editedItem.name'
                        :maxlength='max'
                        :rules='countyRules'
                        hint='Please enter county name.'
                        label='County name*'
                        validate-on-blur
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                       <v-autocomplete @change="filterState" v-model='editedItem.countryId'
                        :items="countryList" item-text='name' item-value="id" :rules="countryRules"
                        label="Country*" required ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                       <v-autocomplete  v-model='editedItem.stateId' :disabled="!isEditingState"
                        :items="stateList" item-text='name' item-value="id" :rules="stateRules"
                        label="State*" required ></v-autocomplete>
                        <span v-if="stateErrorCheck" class="caption fonte-weigth-light red--text">{{stateError}}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model='editedItem.fips'
                        :rules='fipsRules'
                        hint='Please enter a unique 3-digit County FIPS number.'
                        :maxlength='mx'
                        minlength='2'
                        label='FIPS'
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-autocomplete
                        v-model='editedItem.profileId'
                        :items="adoptionProfileList"
                        item-text='name'
                        item-value="id"
                        label='Adoption Profile'
                        persistent-hint
                        clearable
                        hint=' Select from the dropdown how the Jurisdiction handles the adoption process.'
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-autocomplete @change="amendmentAllowed"
                        v-model='editedItem.amendmentsAllowed'
                        :items="['NA', 'YES', 'NO']"
                        label='Amendments Allowed'
                        persistent-hint
                        hint='Will the Jurisdiction adoption allow amendments YES / NO?'
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-autocomplete
                        :disabled="!isEditing"
                        @change="amendmentMadeAllowed"
                        hint="Amendments have been made YES / NO."
                        v-model='editedItem.amendmentsMade'
                        :items="['NA', 'YES', 'NO']"
                        item-text='name'
                        item-value='id'
                        label='Amendments Made'
                        persistent-hint
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field validate-on-blur
                        :disabled="!isEditingAmendments"
                        v-model='editedItem.amendments'
                        hint="Please select 'Amendments Made' as 'Yes' to edit this field."
                        label='Amendments'
                        :rules = "!isEditingAmendments ? undefined : amendmentRules"
                        required
                        persistent-hint
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-text-field type="url" :rules='urlRules' validate-on-blur
                        v-model='editedItem.url'
                        hint='The State home website.'
                        label='Code Office URL'
                        clearable
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-file-input
                        accept="image/png, image/jpg"
                        label='Attach Logo File'
                        persistent-hint
                        hint="Attach an image of your logo. Recommended dimensions 250*100px"
                        v-model="chosenFile"
                        :rules='[IsValidImage]'
                        @change="importLogoFile"
                        clearable
                        >
                      </v-file-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col v-if="editedFields" >
                      <v-select
                        v-model='editedItem.status'
                        :items="statusItems"
                        label="Status*"
                        :rules="statusValidationRules"
                        item-text="statusText"
                        item-value="statusVal"
                      ></v-select>
                    </v-col>
                    <v-col v-else >
                      <v-select
                        v-model='defaultStatus'
                        :items="defaultStatusItems"
                        label="Status*"
                        :rules="statusValidationRules"
                        id="statusFieldId"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-textarea
                        v-model='editedItem.adoptionDescription'
                        label="Adoption Description"
                        hint="Add Adoption Description"
                        placeholder="Add Adoption Description"
                        clearable
                        dense
                        rows=3
                        filled
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-textarea
                        v-model='editedItem.usefulLinks'
                        label="Useful Links"
                        hint="Add legend and link in pair, like legend1||link1, legend2||link2. For multiple entry use comma(,) as separated"
                        placeholder="Add Useful Links"
                        persistent-hint
                        clearable
                        dense
                        rows=3
                        filled
                      ></v-textarea>
                    </v-col>
                  </v-row>
                   <!-- Below fields will view only on edit county form.
                      All below fields will be in disable mode.
                   -->
                  <v-row v-if="editedFields">
                  <v-col>
                      <v-text-field disabled v-model='editedItem.createdBy'
                      label='Created By'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedFields">
                    <v-col>
                      <v-text-field disabled v-model='editedItem.createdDate'
                      label='Created On'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedFields && (editedItem.createdDate !== editedItem.modifiedDate)">
                    <v-col>
                      <v-text-field disabled v-model='editedItem.modifiedBy'
                      label='Modified By'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row v-if="editedFields && (editedItem.createdDate !== editedItem.modifiedDate)">
                    <v-col>
                      <v-text-field disabled v-model='editedItem.modifiedDate'
                      label='Modified On'></v-text-field>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <small color="primary">*indicates required fields</small>
                    <v-spacer></v-spacer>
                    <v-btn outlined dark color='red' @click='close'>
                      <v-icon dark>mdi-close</v-icon>Cancel
                    </v-btn>
                    <v-btn :loading='btnLoader' outlined class='fontcolor' @click='save'>
                      <v-icon dark>mdi-check</v-icon>Save
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action='{ item }'>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text small class='mr-2' @click='editItem(item,1)'>mdi-eye</v-icon>
          </template>
          <span>View Adoptions</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text small class='mr-2' @click="bulkEditUrl(item, '2')" >mdi-format-list-checks</v-icon>
          </template>
          <span>Manage Bulk Adoption</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text small class='mr-2' @click='editItem(item,3)'>mdi-border-color</v-icon>
          </template>
          <span>Edit Profile</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }" v-if="item.status === 1">
            <v-icon v-on="on" text small class='mr-2' @click="validatecountyItem(item)">delete</v-icon>
          </template>
          <span>Delete Profile</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" text small class='mr-2' @click='goToPublicProfileUrlFromAdmin(2, item.stateName, item.name)' >mdi-launch</v-icon>
          </template>
          <span>End User View</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <p>{{ NO_DATA_FOUND }}</p>
      </template>
    </v-data-table>
    <ConfirmationBox :dialog="deleteDialog" :title="modelTitle" :discription="dialogDiscription" :cancel="closeDeleteBox" :confirm="confirmDeleteCountyItem" :btnLoader="btnLoaderConfirm"/>
    <AlertBox :alertDialog="alertDialog"  :discription="alertDiscription" :cancel="closeAlertBox" />
  </v-card>
</template>

<script>
import CONSTANTS from './../../../../config/constant'

export default {
  name: 'AdminCounties',
  components: {
    ConfirmationBox: () => import('../modelbox/ConfirmationBox.vue'),
    AlertBox: () => import('../modelbox/AlertBox.vue')
  },
  data: () => ({
    modelTitle: '',
    alertDiscription: '',
    alertDialog: false,
    btnLoaderConfirm: false,
    deleteDialog: false,
    dialogDiscription: '',
    amendmentsMax: 100,
    isEditingAmendments: false,
    chosenFile: undefined,
    isEditing: false,
    search: '',
    NO_DATA_FOUND: CONSTANTS.NO_DATA_FOUND,
    TABLE_TITLE: CONSTANTS.MANAGE_COUNTY,
    SEARCH_COUNTY: CONSTANTS.SEARCH_COUNTY,
    ADD_NEW_COUNTY: CONSTANTS.ADD_NEW_COUNTY,
    loading: true,
    dialog: false,
    isEditingState: false,
    valid: true,
    edited: false,
    stateErrorCheck: false,
    stateError: null,
    max: 50,
    maxAbbreviation: 5,
    timeout: 10000,
    deletePopUp: false,
    btnLoader: false,
    mx: 3,
    countyRules: [
      v => !!v || 'County name is required.'
    ],
    countryRules: [v => !!v || 'Country name is required.'],
    stateRules: [v => !!v || 'State name is required.'],
    statusValidationRules: [
      v => !!v || 'Status is required.'
    ],
    fipsRules: [
      v => {
        if (v && !/^[0-9]+$/.test(v)) {
          return 'Invalid input. Only 3-digit numeric value (0-9) is allowed!'
        } else {
          return true
        }
      }, v => {
        if (v && v.length !== 3) {
          return 'Invalid input. Only 3-digit numeric value (0-9) is allowed!'
        } else {
          return true
        }
      }],
    urlRules: [v => {
      if (v && !/(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]+$/.test(v)) {
        return 'Please enter a valid URL'
      } else {
        return true
      }
    }],
    amendmentRules: [v => {
      if (v && !/(http[s]?:\/\/)?[^\s(["<,>]*\.[^\s[",><]+$/.test(v)) {
        return 'Please enter a valid URL'
      } else if (v === '') {
        return 'Please enter a valid URL'
      } else {
        return true
      }
    }],
    amendments: [value => !!value || 'Amendments is required.'],
    defaultStatus: CONSTANTS.DEFAULT_RECORDS_STATUS,
    statusValues: CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE,
    defaultStatusItems: CONSTANTS.RECORDS_STATUS,
    statusItems: [
      { statusText: 'Inactive', statusVal: 1 },
      { statusText: 'Published', statusVal: 2 }
    ],
    headers: [
      {
        text: 'ID',
        align: 'left',
        sortable: true,
        value: 'id',
        class: 'title'
      },
      {
        text: 'County Name',
        value: 'name',
        sortable: true,
        class: 'title'
      },
      {
        text: 'FIPS',
        value: 'fipValue',
        sortable: false,
        class: 'title'
      },
      {
        text: 'State',
        value: 'stateName',
        sortable: false,
        class: 'title'
      },
      {
        text: 'Country',
        value: 'countryName',
        sortable: false,
        class: 'title'
      },
      {
        text: 'Status',
        value: 'statusText',
        sortable: true,
        class: 'title'
      },
      { text: 'Actions', value: 'action', sortable: false, class: 'title' }
    ],
    editedIndex: -1,
    deleteIndex: -1,
    editedItem: {
      name: '',
      abbreviation: '',
      countryId: '',
      fips: '',
      createdBy: '',
      createdDate: '',
      modifiedBy: '',
      modifiedDate: '',
      stateId: '',
      status: '',
      profileId: '',
      profileName: 'NA',
      amendmentsAllowed: 'NA',
      amendmentsMade: 'NA',
      amendments: '',
      url: '',
      chosenFile: undefined,
      adoptionDescription: '',
      usefulLinks: ''
    },
    filterItem: {
      countryId: '',
      stateId: '',
      id: '',
      fipsId: '',
      fstatus: ''
    },
    defaultItem: {
      countryId: '',
      stateId: '',
      id: '',
      fipsId: '',
      fstatus: ''
    },
    loadingCountry: true,
    loadingState: true,
    loadingCounty: true,
    loadingFips: true
  }),
  mounted () {
    this.initialize()
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add New County' : 'Edit County'
    },
    counties () {
      return this.$store.getters['CountyModule/fetchCountyList']
    },
    userId () {
      return this.$store.getters['AuthModule/getUserId']
    },
    countryList () {
      let cList = this.$store.getters['CountryModule/fetchCountryList']
      if (Object.keys(cList).length !== 0) {
        let newCList = this.$globalStates.makeUSAAsFirstItem(cList)
        return newCList
      } else {
        return cList
      }
    },
    stateList () {
      return this.$store.getters['StateModule/fetchStateList']
    },
    searchCountyList () {
      return this.$store.getters['CountyModule/fetchSearchCountyList']
    },
    fipsList () {
      return this.$store.getters['CountyModule/fetchCountyFipsList']
    },
    editedFields () {
      return this.edited
    },
    adoptionProfileList () {
      let adoptionList = this.$store.getters['AdoptionProfileModule/fetchAdoptionProfileList']
      if (adoptionList.length > 0) {
        let newAdoptionList = this.$globalStates.makeNAAsFirstItem(adoptionList)
        return newAdoptionList
      } else {
        return adoptionList
      }
    }
  },
  methods: {
    customCountyName: item => item.name + ', ' + item.stateAbbr,
    initialize () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getStateList', { resolve, reject, fetchOnlyPublished })
      }).then(responseData => {
        this.isEditingCounty = false
        this.loadingState = false
      }).catch(response => {
        this.isEditingCounty = false
        this.isEditingState = false
        this.loadingState = false
      })
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', { resolve, reject })
      })
        .then(responseData => {
          this.loading = false
          this.loadingCounty = false
        })
        .catch(({ response }) => {
          this.loading = false
          this.loadingCounty = false
        })
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountryModule/getCountryList', { resolve, reject, fetchOnlyPublished })
      }).then((responseData) => {
        this.loading = false
        this.loadingCountry = false
        const status = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
        new Promise((resolve, reject) => {
          this.$store.dispatch('AdoptionProfileModule/getAdoptionProfileList', {
            resolve,
            reject,
            status
          })
        })
          .then(responseData => {
            // add loader on button if required
          })
          .catch(response => {
            // add loader on button if required
          })
      }).catch(({ response }) => {
        this.loadingCountry = false
        this.loading = false
      })

      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyFips', {
          resolve,
          reject
        })
      }).then(responseData => {
        this.loadingFips = false
      }).catch(response => {
        this.loadingFips = false
      })
      this.searchCounties()
    },
    onReset () {
      Object.assign(this.filterItem, this.defaultItem)
      this.loading = true
      this.resetBtnLoader = true
      let searchData = this.defaultItem
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/searchCountyItem', { resolve, reject, searchData })
      }).then((responseData) => {
        this.resetBtnLoader = false
        this.loading = false
      }).catch(({ response }) => {
        this.resetBtnLoader = false
        this.loading = false
      })
    },
    searchCounties () {
      this.btnLoader = true
      this.loading = true
      let searchData = { ...this.filterItem }
      if (searchData.fstatus === 'Inactive') {
        searchData.fstatus = 1
      }
      if (searchData.fstatus === 'Published') {
        searchData.fstatus = 2
      }
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/searchCountyItem', { resolve, reject, searchData })
      }).then((responseData) => {
        this.btnLoader = false
        this.loading = false
      }).catch((response) => {
        this.btnLoader = false
        this.loading = false
      })
    },
    amendmentAllowed () {
      if (this.editedItem.amendmentsAllowed === 'YES') {
        this.isEditing = true
      } else {
        this.isEditingAmendments = false
        this.isEditing = false
        this.editedItem.amendmentsMade = 'NA'
        this.editedItem.amendments = 'NA'
      }
      return this.isEditing
    },
    amendmentMadeAllowed () {
      if (this.editedItem.amendmentsMade === 'YES') {
        this.isEditingAmendments = true
      } else {
        this.isEditingAmendments = false
        this.editedItem.amendments = 'NA'
      }
      return this.isEditingAmendments
    },
    editItem (county, navId) {
      // route push to edit page
      if (navId === 3) {
        this.$router.push({ name: 'AdminEditCounty', params: { id: county.id, tabId: 3 } })
      }
      if (navId === 1) {
        this.$router.push({ name: 'AdminEditCounty', params: { id: county.id, tabId: 1 } })
      }
    },
    bulkEditUrl (id, adoptionLevel) {
      this.$router.push({ name: 'BulkAdoption', params: { adoptionLevel: CONSTANTS.BULK_ADOPTION_URL[adoptionLevel], id: id.id } })
    },
    goToPublicProfileUrlFromAdmin (adoptionLevel, sName, cName) {
      let stateName = ''
      let countyName = ''
      if (sName !== '' && sName !== undefined) {
        stateName = sName.replace(/\s+/g, '-')
      }
      if (cName !== '' && cName !== undefined) {
        countyName = cName.replace(/\s+/g, '-')
      }
      switch (adoptionLevel) {
        case 2:
          let routeData = this.$router.resolve({ name: 'CountyCodeAdoption', params: { stateName: stateName, countyName: countyName } })
          window.open(routeData.href, '_blank')
          break
      }
    },
    hideEditedFields () {
      this.edited = false
    },
    close () {
      this.btnLoader = false
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, {})
        this.valid = false
        this.editedIndex = -1
      }, 300)
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.editedItem.status = CONSTANTS.DEFAULT_RECORDS_STATUS
      this.defaultStatus = CONSTANTS.DEFAULT_RECORDS_STATUS
      this.isEditingState = false
      this.stateErrorCheck = false
    },
    filterState () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      const countryId = this.filterItem.countryId
      new Promise((resolve, reject) => {
        this.$store.dispatch('StateModule/getStateList', {
          resolve,
          reject,
          countryId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.stateErrorCheck = false
          // add loader on button if required
        })
        .catch(response => {
          this.isEditingState = false
          this.editedItem.stateId = null
          this.stateErrorCheck = true
          this.stateError = CONSTANTS.NO_STATE_IS_AVAILABLE_FOR_THE_SELECTED_COUNTRY
          // add loader on button if required
        })
    },
    filterCounty () {
      let fetchOnlyPublished = CONSTANTS.DEFAULT_RECORDS_STATUS_VALUE.Published
      const stateId = this.filterItem.stateId
      const countryId = this.filterItem.countryId
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/getCountyList', {
          resolve,
          reject,
          countryId,
          stateId,
          fetchOnlyPublished
        })
      })
        .then(responseData => {
          this.tempCounty = responseData
          // add loader on button if required
        }
        )
        .catch(response => {
          this.tempCounty = []
          // add loader on button if required
        })
      // reset jurisdiction dropdown
      this.tempJurisdictionList = []
    },
    save () {
      if (this.editedIndex > -1 && this.$refs.form.validate()) {
        this.btnLoader = true
        Object.assign(this.editedItem)
        let editCountyData = this.editedItem
        const editedData = {
          name: editCountyData.name,
          stateId: Number(editCountyData.stateId),
          fips: editCountyData.fips,
          countryId: Number(editCountyData.countryId),
          status: editCountyData.status,
          userId: this.userId,
          id: Number(editCountyData.id)
        }
        new Promise((resolve, reject) => {
          this.$store.dispatch('CountyModule/editCountyItem', { resolve, reject, editedData })
        }).then((responseData) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = responseData.responseMessage
          this.$globalStates.notification.init_notifications = true
          this.close()
        }).catch((response) => {
          this.btnLoader = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
          this.$globalStates.notification.init_notifications = true
        })
      } else {
        if (this.$refs.form.validate()) {
          this.btnLoader = true
          let statusField = 1
          if (this.defaultStatus === 'Inactive') {
            statusField = this.statusValues.Inactive
          } else if (this.defaultStatus === 'Published') {
            statusField = this.statusValues.Published
          }
          let editCountyData = this.editedItem
          let formData = new FormData()
          formData.append('name', editCountyData.name)
          formData.append('stateId', Number(editCountyData.stateId))
          formData.append('fips', editCountyData.fips)
          formData.append('countryId', Number(editCountyData.countryId))
          formData.append('userId', this.userId)
          formData.append('status', statusField)
          formData.append('adoptionProfile', editCountyData.profileId === undefined ? '' : editCountyData.profileId)
          formData.append('amendmentsAllowed', editCountyData.amendmentsAllowed)
          formData.append('amendmentsMade', editCountyData.amendmentsMade)
          formData.append('url', editCountyData.url)
          formData.append('amendments', editCountyData.amendments)
          formData.append('logo', this.chosenFile)
          formData.append('adoptionDescription', editCountyData.adoptionDescription)
          formData.append('usefulLinks', (editCountyData.usefulLinks !== undefined || editCountyData.usefulLinks !== null) ? editCountyData.usefulLinks : '')
          new Promise((resolve, reject) => {
            this.$store.dispatch('CountyModule/addCountyItem', { resolve, reject, formData })
          }).then((responseData) => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'green'
            this.$globalStates.notification.text = responseData.responseMessage
            this.$globalStates.notification.init_notifications = true
            this.close()
          }).catch((response) => {
            this.btnLoader = false
            this.$globalStates.notification.type = 'error'
            this.$globalStates.notification.text = this.$globalFromValidation.getErrorMessageText(response.responseMessage)
            this.$globalStates.notification.init_notifications = true
          })
        }
      }
    },
    IsValidImage (v) {
      if (v) {
        const val = v.name
        if (
          val &&
          val !== undefined &&
          val !== null &&
          val.slice(val.lastIndexOf('.') + 1) !== 'png' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'jpg' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'PNG' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'JPG' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'jpeg' &&
          val.slice(val.lastIndexOf('.') + 1) !== 'JPEG'
        ) {
          return 'Invalid Input. Excepted file formats are .jpg and .png'
        } else {
          return true
        }
      } else {
        return true
      }
    },
    importLogoFile (e) {
      if (!this.chosenFile) {
        this.chosenFile = undefined
      }
      this.chosenFile = e
      return this.chosenFile
    },
    // DELETE COUNTY FUNCTIONS START FROM HERE --------------
    closeDeleteBox () {
      this.deleteDialog = false
    },
    closeAlertBox () {
      this.alertDialog = false
    },
    validatecountyItem (item) {
      let formData = {
        userId: this.userId,
        id: item.id,
        isValidation: true
      }
      this.deleteIndex = item.id
      new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/validateCountyItem', { resolve, reject, formData })
      }).then((responseData) => {
        this.modelTitle = 'Delete County'
        this.deleteDialog = true
        this.dialogDiscription = "'" + item.name + "'" + ' ' + 'County'
      }).catch((response) => {
        this.alertDialog = true
        this.alertDiscription = response.responseMessage.replace(/\./g, ' ') + "'" + item.name + "'" + ' ' + 'County.'
      })
    },
    confirmDeleteCountyItem () {
      this.btnLoaderConfirm = true
      const formData = { userId: this.userId, id: this.deleteIndex }
      let isPromise = new Promise((resolve, reject) => {
        this.$store.dispatch('CountyModule/deleteCountyItem', { resolve, reject, formData })
      })
      isPromise
        .then((response) => {
          this.deleteIndex = -1
          this.deleteDialog = false
          this.btnLoaderConfirm = false
          this.$globalStates.notification.type = 'green'
          this.$globalStates.notification.text = response.responseMessage
          this.$globalStates.notification.init_notifications = true
        })
        .catch((response) => {
          this.deleteIndex = -1
          this.deleteDialog = false
          this.$globalStates.notification.type = 'error'
          this.$globalStates.notification.text = response.responseMessage
          this.$globalStates.notification.init_notifications = true
        })
    }
  }
}
</script>
